import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fa13c472"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-app-modal__title" }, " This is a FREE feature exclusively available in our app ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-app-modal__text" }, " Download our app to gain a free access to a variety of tools, including therapist advice, community support, self-therapy videos, and much more. ", -1))

import BaseModal from '@/components/modals/BaseModal.vue';
import { Browser } from '@capacitor/browser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallAppModal',
  props: {
    isOpened: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function close() {
  if (props.isOpened) {
    emit('close');
  }
}

function openAppleStore() {
  Browser.open({
    url: 'https://apps.apple.com/app/feelyou/id1673720647',
  });
  close();
}
function openGoogleStore() {
  Browser.open({
    url: 'https://play.google.com/store/apps/details?id=io.feelyou.app',
  });

  close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    class: "install-app-modal",
    onClose: close
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", { class: "install-app-modal__buttons" }, [
        _createElementVNode("img", {
          src: "/assets/app-store-banner.png",
          onClick: openAppleStore
        }),
        _createElementVNode("img", {
          src: "/assets/google-play-banner.png",
          onClick: openGoogleStore
        })
      ])
    ]),
    _: 1
  }, 8, ["is-opened"]))
}
}

})